import React from "react";
import "./Dashboard.css";

/**
 * DashboardStats - Reusable stat cards component
 *
 * @param {Array} stats - Array of stat objects with:
 *   - label: string (e.g., "Total Schools")
 *   - value: string|number (e.g., "12" or 12)
 *   - icon: string (FontAwesome icon class, e.g., "fa-graduation-cap")
 *   - colorClass: string (e.g., "dashboard-stat-card-purple")
 * @param {string} className - Optional additional class names
 */
export const DashboardStats = ({ stats = [], className = "" }) => {
  return (
    <div className={`row mb-4 ${className}`}>
      {stats.map((stat, index) => (
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-3" key={index}>
          <div className={`dashboard-stat-card ${stat.colorClass || ""}`}>
            <div className="dashboard-stat-icon">
              <i className={`fa-solid ${stat.icon}`}></i>
            </div>
            <div className="dashboard-stat-content">
              <p className="dashboard-stat-label mb-0">{stat.label}</p>
              <p className="dashboard-stat-value">{stat.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;
